angular
  .module 'memberPortal'
  .controller 'BookingsCtrl', (
    $scope,
    $state,
    $stateParams,
    $http,
    $filter,
    DataService
    Bookings
  ) ->
    $scope.data = DataService
    domain = $scope.data.domain
    $scope.hash = $stateParams.m
    $scope.isLoading = true
    $scope.bookings = []
    $scope.page = 1

    $scope.displayTime = (time, booking)->
      if booking.event_tz_type is 'browser'
        moment.utc(time, 'YYYY/MM/DD HH:mm').local().format('ddd, D MMM – h:mma')
      else
        moment(time, 'YYYY/MM/DD HH:mm').format('ddd, D MMM – h:mma')

    $scope.displayStatus = (booking) ->
      switch
        when booking.member_portal_booking_status
          booking.member_portal_booking_status
        when booking.on_waitlist
          order = $filter('ordinalize')(booking.waitlist_position)
          "(#{order} on waitlist)"

    $scope.loadMore = ->
      return if $scope.isLoading || $scope.bookings.length >= $scope.total
      $scope.page = $scope.page + 1
      loadBookings()

    $scope.bookingDetails = (booking) ->
      [booking.location_name, booking.instructor_names].join(', ')

    loadBookings = ->
      Bookings.getList(count: 10, page: $scope.page).then (bookings) ->
        $scope.total = bookings.meta.total
        $scope.isLoading = false
        $scope.bookings =
          if $scope.page > 1
            $scope.bookings =
              _.sortBy [].concat($scope.bookings, bookings.plain()), 'start_at'
          else
            bookings.plain()

    loadBookings()
